import { required } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import "vue-toastification/dist/index.css"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "El campo {_field_} no puede estar vacio"
})
const auth = {
    components: { ValidationProvider, ValidationObserver },
    data: () => ({
        loading: false,
        step: 1,
        imageUrl: '/imgs/Business-Background-PNG.png',
        rememberMe: false,
        user: {
            user: null,
            password: null
        }
    }),
    beforeCreate() {
        if(localStorage.getItem('token')?.length > 0){
            this.$router.push("/main");
        }
    },
    methods: {
        async login() {
            this.loading = true
            var payload = {
                access: this.user.user + '†' + this.user.password
            };
            try {
                const response = await this.$axios.post('login', payload);
                if (response.data.status === 'success') {
                    // Extraer los valores
                    const rawData = response.data.data[0].fn_sic_login;
                    const [userData, menuData] = rawData.split('¥');

                    const values = userData.split('†');
                    //console.log(values);

                    const UserName = values[1] + ' ' + values[2] + ' ' + values[3];
                    const DocuID = values[8];
                    const RolPerfil = values[6];
                    const Nivel = values[10];
                    const Id = values[0];

                    const centrosAsignados = values[21] ? values[21].split(',') : [];
                    const campanasAsignadas = values[22] ? values[22].split(',') : [];

                    // Guardar datos en localStorage o sessionStorage según el checkbox "Recordarme"
                    // if (this.rememberMe) {
                        localStorage.setItem("token", DocuID);
                    // } else {
                        sessionStorage.setItem("token", DocuID);
                    // }
                    this.$store.commit('setUsername', UserName)
                    this.$store.commit('setRole', RolPerfil)
                    this.$store.commit('setNivel', Nivel)
                    this.$store.commit('setId', Id)
                    this.$store.commit('setAuth', true)

                    this.$store.commit('setCentrosAsignados', centrosAsignados);
                    this.$store.commit('setCampanasAsignadas', campanasAsignadas);

                    // Hacer fetch de los datos iniciales
                    await this.fetchInitialData();

                    // Validar cambio de password
                    if (this.resetPassword(values[14])) {
                        this.$router.push("/reset/password");
                    } else {
                        this.$router.push("/main");
                    }

                    // Mostrar mensaje de éxito
                    this.$toast.success(`Bienvenido ${UserName}`, {
                        timeout: 1400,
                    });
                } else if (response.data.status === 'no_data') {
                    // Mostrar mensaje de no datos
                    this.$toast.error("Error en las credenciales de acceso", {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                }
            } catch (error) {
                // Manejar error en la solicitud
                this.$toast.error("Error en la solicitud: " + error.message, {
                    position: "bottom-left",
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
            } finally {
                this.loading = false
            }
        },
        async fetchInitialData() {
            await this.$store.dispatch('fectSegment');
            await this.$store.dispatch('fetchCountry');
            await this.$store.dispatch('fetchCenter');
            await this.$store.dispatch('fetchCampaign');
            await this.$store.dispatch('fectMenu');
        },
        resetPassword(timePassword) {
            if (timePassword.length == 0) {
                return true;
            }

            let lastDatePass = new Date(timePassword);
            let nextDatepass = lastDatePass.setMonth(lastDatePass.getMonth() + 3);
            let now = Date.now();


            if (now > nextDatepass) {
                return true;
            }

            return false;

        }
    }
}
export default auth